export const SAVE_DAS_PARAMETERS = "SAVE_DAS_PARAMETERS";
export const CLEAR_DAS_PARAMETERS = "CLEAR_DAS_PARAMETERS";
